import React, { startTransition } from 'react';
import { useTranslation } from 'react-i18next';

import { useTranslationContext } from '../context/TranslationContext';
import {
  TranslationKeys,
  defaultResource,
} from '../i18n/locales/defaultResources';
import { useContextStore } from '../stores/storeRoot';
import { CropConnectLanguages } from '../services/cropConnectApiClient';

export function useI18n() {
  const { i18n } = useTranslation();
  const { isTranslationMode, setActiveKey } = useTranslationContext();
  const { selectedUserLanguage } = useContextStore();

  const translate = (
    key: TranslationKeys,
    options?: Record<string, unknown>
  ): React.ReactNode => {
    const translationKey = `${CropConnectLanguages[selectedUserLanguage as CropConnectLanguages]}.${key}`;
    let translation = '';

    startTransition(() => {
      translation = i18n.t(key, options) as string;

      // Check if the translation exists; if not, use default resources
      if (!translation || translation === key) {
        translation = defaultResource[key] || key;
      }
    });

    if (isTranslationMode) {
      return (
        <span
          // temporary styles for keys
          style={{ background: '#97B053', color: 'black' }}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            setActiveKey(key);
          }}
        >
          {translationKey}
        </span>
      );
    }

    return translation;
  };

  return {
    translateToString: i18n.t,
    t: translate,
    setLang: i18n.changeLanguage,
    handleKeyClick: setActiveKey,
    isTranslationMode,
  };
}
